import { useContext } from "react"
import { Box, Button, Flex, Text } from "@chakra-ui/react"
import { SimilaritySearchContext } from "./SimilaritySearchContainer"
import { CheckIcon } from "../../icons"
import FilterInstrumentalIcon from "../../icons/FilterInstrumentalIcon"
import FilterVocalsIcon from "../../icons/FilterVocalsIcon"
import FilterVocalsFemaleIcon from "../../icons/FilterVocalsFemaleIcon"
import FilterVocalsMaleIcon from "../../icons/FilterVocalsMaleIcon"

const voiceOptions = [
  { label: "Instrumental", value: "instrumental", icon: FilterInstrumentalIcon },
  { label: "All Vocals", value: "vocals", icon: FilterVocalsIcon },
  { label: "Female", value: "female", icon: FilterVocalsFemaleIcon },
  { label: "Male", value: "male", icon: FilterVocalsMaleIcon },
]

const SimilaritySearchFilters = () => {
  const { filters, setFilters } = useContext(SimilaritySearchContext)
  const selected = filters.voice

  const handleClick = (value) => {
    setFilters((prev) => ({
      ...prev,
      voice: prev.voice === value ? "" : value,
    }))
  }

  return (
    <Flex
      wrap="wrap"
      gap="12px"
      py="1rem"
      justifyContent="center"
      alignItems="center"
      aria-label="Similarity Search Filters"
    >
      {voiceOptions.map(({ label, value, icon: Icon }) => {
        const isSelected = selected === value

        return (
          <Button
            key={value}
            onClick={() => handleClick(value)}
            leftIcon={<Icon width="15px" height="15px" fillColor={isSelected ? "white" : "var(--purple)"} />}
            rightIcon={
              isSelected && (
                <CheckIcon width="15px" height="15px" fillColor="white" />
              )
            }
            borderRadius="20px"
            height="40px"
            px="20px"
            fontSize=".8rem"
            fontFamily="TTCommonsMedium"
            textTransform="uppercase"
            backgroundColor={isSelected ? "var(--purple)" : "white"}
            border={isSelected ? "2px solid var(--purple)" : "2px solid var(--light-purple)"}
            color={isSelected ? "white" : "var(--purple)"}
            _hover={{
              backgroundColor: "var(--purple)",
              color: "white",
              borderColor: "var(--purple)",
            }}
            _active={{
              backgroundColor: "var(--purple)",
              color: "white",
              borderColor: "var(--purple)",
            }}
            data-cy={`vocals-option-${label}`}
          >
            {label}
          </Button>
        )
      })}
    </Flex>
  )
}

export default SimilaritySearchFilters
